import { useEffect, useRef, useState } from 'react'
import allImgPaths from 'assets/images';
import RfpDrag from './RfpDrag';
import ConfirmationModal from 'components/common/modal/ConfirmationModal';

const RfpInnerLogo = ({ data: dataObj, index, setItemData, removeItem, dragItem }: any) => {
    const [isChecked, setIsChecked] = useState(dataObj?.showLabel || false);
    const [errorMessage, setErrorMessage] = useState('');
    const initValues = {
        file: null,
        filename: "Click to Upload",
        imageUrl: "",
        originalImageUrl: ""
    }

    useEffect(() => {
        if (dataObj?.updatedTime) {
            if (dataObj?.content?.file) {
                const content = dataObj?.content
                setIsNewImageUploaded(false);
                const updatedContent = {
                    filename: content?.filename,
                    originalImageUrl: content?.originalImageUrl,
                    file: content.file,
                    imageUrl: content.imageUrl,
                    isNewImageUploaded: false,
                    previewUrl: content.previewUrl,
                    width: content?.width,
                    height: content?.height
                }
                setIsChecked(dataObj?.showLabel || false)
                setFormData(updatedContent);
                setItemData({ index, content: updatedContent, showLabel: isChecked })
            }
        }
    }, [dataObj?.updatedTime])

    const [formData, setFormData] = useState<any>(initValues);
    const [isNewImageUploaded, setIsNewImageUploaded] = useState(false)
    const actualBtnRef = useRef<any>(null);
    const [showDeleteModal, setShowDeleteModal] = useState(false);

    const handleCheckboxChange = (isChecked: boolean) => {
        setIsChecked(isChecked);
        setItemData({ index, content: formData, showLabel: isChecked })
    };

    const drag = (position: string) => {
        dragItem({ index, position })
    }

    const handleChange = (e: any) => {
        if (e.target.files.length > 0) {
            setErrorMessage('');
            if (dataObj?.other?.custom) {
                const fileSizeInMB = e.target.files[0].size / 1024 / 1024;
                if (fileSizeInMB > 1) {
                    setErrorMessage('File size exceeds 5MB. Please select a smaller file.');
                    return
                }
            }

            const tempUrl = URL.createObjectURL(e.target.files[0]);
            const fileName = e.target.files[0].name;
            const updatedContent = {
                filename: fileName, originalImageUrl: fileName, file: e.target.files[0], imageUrl: tempUrl, isNewImageUploaded: true, previewUrl: tempUrl
            }
            console.log({ updatedContent })
            setFormData({ ...formData, ...updatedContent });
            setIsNewImageUploaded(true)

            setItemData({ index, content: updatedContent, showLabel: isChecked })
        }
    };

    const removeFile = (e: any) => {
        const updatedContent = {
            filename: 'Click to Upload', originalImageUrl: '', file: null, imageUrl: '', previewUrl: ''
        }
        setFormData({ ...formData, ...updatedContent });
        setItemData({ index, content: updatedContent, showLabel: isChecked })
    };

    const remove = () => {
        setShowDeleteModal(true)
    }

    const confirmDelete = () => {
        removeItem({ index })
    }

    return (
        <>
            {
                showDeleteModal &&
                <ConfirmationModal
                    headerText={'Delete'}
                    bodyText={``}
                    setShowDeleteModal={setShowDeleteModal} confirmDelete={confirmDelete}
                />
            }
            <div className="border border-[#F0F0F0] bg-[#F9F9F9] rounded-sm flex mb-6">

                {/* Drag */}
                <RfpDrag dragItem={drag} />

                {/* Content */}
                <div className="w-full py-2 pr-2">
                    <div className="mb-2 flex justify-between items-center px-0.5">
                        <span className='font-interMedium text-sm text-[#344054]'>{dataObj.title || 'No Title'}</span>
                        <div className='rfp-custom-checkbox'>
                            <input
                                type='checkbox'
                                name={'rfpName'}
                                checked={isChecked || false}
                                onChange={(e) => handleCheckboxChange(e.target.checked)}
                                style={{ width: '16px', height: '18px', cursor: 'pointer' }}
                            />
                            <label
                                className={`font-interMedium`}
                            >
                                <span className={`custom-checkbox-label font-interRegular text-sm text-[#667085] pl-1.5`}>Show label in draft</span>
                            </label>
                        </div>
                    </div>

                    <div className={`border border-[#D0D5DD] rounded-lg px-4 py-3 bg-[#fff] relative group`}>
                        <div className='flex items-center justify-between'>
                            {!formData?.imageUrl && (
                                <>
                                    <div className='flex'>
                                        <input
                                            type='file'
                                            id='email-upload-btn'
                                            ref={actualBtnRef}
                                            onChange={handleChange}
                                            hidden
                                            style={{ 'display': 'none' }}
                                            accept=".png,.jpg,.jpeg"
                                        />
                                        <div className="flex items-center gap-x-2 cursor-pointer text-[#D0D5DD]" onClick={() => actualBtnRef?.current?.click()}>
                                            <span>{formData.filename}</span>
                                        </div>
                                    </div>
                                </>
                            )}
                            {formData?.imageUrl && (
                                <>
                                    <div className="flex items-center gap-x-2">
                                        <img src={allImgPaths.rfpFileLogo} alt="" />
                                        <span className='truncate max-w-48'>{formData.filename}</span>
                                        <img className="cursor-pointer" src={allImgPaths.closeIcon} alt=""
                                            onClick={removeFile} />
                                    </div>
                                </>
                            )}
                            <img className='cursor-pointer hidden group-hover:block' src={allImgPaths.closeIconRed} alt="" onClick={remove} />
                        </div>
                    </div>
                    {errorMessage && <p className='mt-2 text-[red]'>{errorMessage}</p>}
                </div>

            </div>
        </>
    )
}

export default RfpInnerLogo